import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import DocumentPanel from './DocumentPanel';
import { BaseCard } from '../../../components/wizard';

class DocumentCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    const { record = {}, data = {}, extras, setItem, ...extraProps } = this.props;
    const formdata = data.data || {};
    return (
      <Box>
        <BaseCard
          cardid={'DOCUMENT'}
          cardname={'Document'}
          cardtitle={'Baptism Certificate'}
          instruction={'Capture the certificate details and upload the baptism certificate file.'}
          step={6}
          buttons={['START', 'CANCEL', 'PREV', 'NEXT', 'GUIDE']}
          {...extraProps}
        >
          <DocumentPanel
            data={data}
            record={{ ...record, ...formdata }}
            extras={extras}
            setItem={setItem}
          />
        </BaseCard>
      </Box>
    );
  };
}

DocumentCard.propTypes = {
  classes: PropTypes.object,
};

export default DocumentCard;
